import { Checkbox, CheckboxState } from "react-migration/components/DeprecatedCheckbox";
import { Column, IRow, TableSize } from "./Table";
import clsx from "clsx";

interface TableHeaderProps<Row extends IRow> {
  columns: Column<Row>[];
  selection?: {
    checkboxState: CheckboxState;
    selectAll: (isSelected: boolean) => void;
  };
  size: TableSize;
  headerCellClassName?: (column: Column<Row>) => string | undefined;
}

export function TableHeader<Row extends IRow>({
  columns,
  selection,
  size,
  headerCellClassName,
}: TableHeaderProps<Row>) {
  const getHeaderClass = (alignment = "left") => {
    return clsx("sticky", "top-0", "bg-neutral-50", "py-4", "font-semibold", "text-sm", "text-text-base-secondary", {
      "text-right": alignment === "right",
      "text-left": alignment === "left",
      "text-center": alignment === "center",
      "px-3": size === "small",
      "px-6": size !== "small",
    });
  };

  return (
    <thead
      className={clsx("min-w-full", "border-b", "border-x-0", "border-t-0", "border-solid", "border-border-action")}
      data-testid="table-head"
    >
      <tr>
        {selection && (
          <th className={clsx("pt-1", "bg-neutral-50", "sticky", "top-0", "pl-4", "text-left")}>
            <Checkbox value={selection.checkboxState} onChange={selection.selectAll} />
          </th>
        )}
        {columns.map((column, colIdx) => {
          const { label, align, rowKey, maxWidth, colSpan } = column;
          return (
            <th
              key={`header-col-${(rowKey ?? colIdx).toString()}`}
              scope="col"
              style={{ width: maxWidth }}
              colSpan={colSpan}
              className={clsx(getHeaderClass(align), headerCellClassName?.(column))}
            >
              {label}
            </th>
          );
        })}
      </tr>
    </thead>
  );
}
